import { Tag, TagProps } from '@repo/ui'
import { BfnStatus } from '@/models/Befehlsnachricht'
import { cn } from '@/utils/classnames'
import {
  tfStatusStyle,
  tfStatusText
} from '@/features/befehlsnachrichten/utils/befehlsnachricht-status'

export interface BefehlsnachrichtStatusTagProps extends TagProps {
  status: BfnStatus
  visuellerStatus: string
  manuellWiderrufen: boolean
  'data-testid': string
}

export default function BfnStatusTag({
  status,
  visuellerStatus,
  manuellWiderrufen,
  className,
  'data-testid': testId,
  ...props
}: Readonly<BefehlsnachrichtStatusTagProps>) {
  const statusStyle = tfStatusStyle(status, manuellWiderrufen)

  return (
    <Tag
      className={cn(
        `${statusStyle.backgroundColor} ${statusStyle.textColor} ${statusStyle.darkBackgroundColor}`,
        className
      )}
      data-testid={testId}
      {...props}
    >
      <span data-testid={`${testId}-text`}>
        {tfStatusText(status, visuellerStatus, manuellWiderrufen)}
      </span>
    </Tag>
  )
}
